import React from "react";
import { useState, useEffect } from "react";
import "../styles/css/bootstrap.min.css";
import "../styles/Banner.css";
import logo from "../assets/logo/logo.jpg";

export default function ServicemultiEtats() {
  //eagrimet.online
  //const urlget = "http://localhost:8000/eagrimetApi/multiEtatsInfo/";
  const urlget = "https://eagrimet.online/eagrimetApi/multiEtatsInfo/";

  const [lstMEInfo, setLstMEInfo] = useState([]);

  useEffect(() => {
    const fetchMEInfos = async () => {
      try {
        const response = await fetch(urlget, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
          },
        });
        if (!response.ok) {
          console.error("Error getting liste pays");
          return;
        }
        const result = await response.json();
        setLstMEInfo(result);
      } catch {
        console.error("Error getting liste pays");
      }
    };
    // Trigger the fetch
    fetchMEInfos();
  }, []);

  return (
    <div className="row float-top  border-bottom border-dark border-3 ">
            
        <div className="d-inline-flex navbar">            
             
            <img src={logo} alt="" className="navbar-brand toplogo rounded-circle" />
              {lstMEInfo.map((meinfo) => {
                return (
                  <ul className="navbar-nav  me-auto"  key={meinfo.code}>
                    <li className="nav-item" >
                      <h5>
                        {" "}
                        Sous Région : &nbsp;
                        <a href={meinfo.bulletinPdf} target="_blank">{meinfo.region}</a>
                      </h5>
                      <h5> Source Infos: {meinfo.sourceinfo}</h5>
                    </li>
                  </ul>
                );
              })}
            
          
            </div>
        </div> 
  );
}
